module.exports = __webpack_public_path__ + "img/charging-hub-request.ccd4654a.svg";